module.exports = __webpack_public_path__ + "img/w9b.479f32ce.jpg";